// Email domain is: aws.com, cisco.com or amazon.com
export function IsAcceptedEmail(email: string) {
  let emailDomain = email?.split("@")[1];

  emailDomain = emailDomain?.toLowerCase?.();
  emailDomain = emailDomain?.trim?.();

  return ["aws.com", "amazon.com", "cisco.com"].includes(emailDomain);
}
